module.exports = "/packs/images/sprites/circular~ef01b168e39d612f6af84246bd4e2a66.png";